export type CategoryId = number & { readonly brand: unique symbol }
export const CategoryId = (id: number): CategoryId => id as CategoryId

export type ChargeId = number & { readonly brand: unique symbol }
export const ChargeId = (id: number): ChargeId => id as ChargeId

export type DealId = number & { readonly brand: unique symbol }
export const DealId = (id: number): DealId => id as DealId

export type DealLineId = number & { readonly brand: unique symbol }
export const DealLineId = (id: number): DealLineId => id as DealLineId

export type DealLineSkuId = number & { readonly brand: unique symbol }
export const DealLineSkuId = (id: number): DealLineSkuId => id as DealLineSkuId

export type DiscountId = number & { readonly brand: unique symbol }
export const DiscountId = (id: number): DiscountId => id as DiscountId

export type OptionId = number & { readonly brand: unique symbol }
export const OptionId = (id: number): OptionId => id as OptionId

export type OptionListId = number & { readonly brand: unique symbol }
export const OptionListId = (id: number): OptionListId => id as OptionListId

export type ProductId = number & { readonly brand: unique symbol }
export const ProductId = (id: number): ProductId => id as ProductId

export type SkuId = number & { readonly brand: unique symbol }
export const SkuId = (id: number): SkuId => id as SkuId

export type VariantId = number & { readonly brand: unique symbol }
export const VariantId = (id: number): VariantId => id as VariantId
